<template>
	<div style="margin-top: 50px">
		<h3>Ligações Recebidas na Semana</h3>
		<apexchart ref="mixedChart" type="line" :options="chartOptions" :series="series" />
	</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
	props: ['filter'],

	data() {
		return {
			series: [],
			chartOptions: {
				chart: {
					height: 350,
					type: 'line',
					stacked: false
				},
				stroke: {
					width: 2
				},
				plotOptions: {
					bar: {
						dataLabels: {
							position: 'center'
						}
					}
				},
				dataLabels: {
					enabled: true
				},
				markers: {
					size: 5,
					hover: {
						sizeOffset: 2
					}
				},
				xaxis: {
					categories: [],
					tickPlacement: 'between'
				},
				tooltip: {
					x: {
						formatter: val => `Dia ${val}`
					}
				},
				legend: {
					horizontalAlign: 'center',
					offsetX: 80
				},
				noData: {
					text: 'Sem dados para exibir...'
				},
				colors: [
					'#008FFB', '#FF4560', '#00E396', '#ffd60a',
					'#775DD0', '#7f4f24', '#00f5d4', '#4d194d', '#333533'
				]
			}
		};
	},

	methods: {
		async fetchWeeklyCalls() {
			try {
				const response = await axios.get(`${window.location.href}/weeklyCallsPerQueue?queue=${this.filter}`);
				const { TotalMonth, PerQueue } = response.data;

				const sortedDays = [...TotalMonth].sort((a, b) => new Date(a.date) - new Date(b.date));
				const categories = sortedDays.map(item => moment(item.date).format('DD/MM/YY'));

				const queueSeries = PerQueue.map(queue => ({
					name: queue.queuename.toUpperCase(),
					type: 'column',
					data: queue.total
				}));

				const daysCount = categories.length;
				const totalByDay = [];

				for (let i = 0; i < daysCount; i++) {
					let dayTotal = 0;
					for (const serie of queueSeries) {
						dayTotal += serie.data[i] || 0;
					}
					totalByDay.push(dayTotal);
				}

				this.series = [
					...queueSeries,
					{
						name: 'TOTAL DO DIA',
						type: 'line',
						data: totalByDay
					}
				];

				this.$refs.mixedChart.updateOptions({
					xaxis: { categories }
				});
			} catch (error) {
				console.error('Erro ao buscar dados semanais:', error);
			}
		}
	},

	created() {
		this.fetchWeeklyCalls();

		this.interval = setInterval(this.fetchWeeklyCalls, 30000);
	},

	beforeDestroy() {
		clearInterval(this.interval);
	},

	watch: {
		filter() {
			this.fetchWeeklyCalls();
		}
	}
};
</script>